import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientProfileChangelogPopover from "@Broker/@Modules/clients/board/client-board/components/changelog/client-profile-changelog-popover.vue";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import { CLEAR_COMPLETE_CLIENT_PROFILE_REMINDERS, UPDATE_CLIENT_PROFILE_REMINDER, LOAD_CUSTOM_FIELDS_DEFINITIONS, MERGE_CUSTOM_FIELDS_DATA } from "@Broker/@Modules/clients/board/store/board-actions";
import ProfileCardSetting from "./profile-card-settings";
import RemindersPopover from "../reminders/reminders-popover";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import ProfileCardCustomFields from "./profile-card-custom-fields";
import Badge from "@Shared/components/general/badge.vue";
import { CUSTOM_FIELDS_DEFINITIONS, SELECTED_BOARD, GET_PROFILE_PARTICIPANTS } from "@Broker/@Modules/clients/board/store/board-getters";
import { debounce, isEmpty, sortBy } from "lodash";
import { REFERRER_TYPE_OPTIONS } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProfileCard",
  components: {
    ProfileCardSetting,
    RemindersPopover,
    ProfileCardCustomFields,
    ProfileAvatar,
    Badge,
    ClientProfileChangelogPopover
  },
  props: {
    id: {
      type: String,
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    statusLabelId: {
      type: String,
      default: ""
    },
    givenName: {
      type: String,
      default: ""
    },
    familyName: {
      type: String,
      default: ""
    },
    daysSinceLastActive: {
      type: Number,
      default: 0
    },
    rottingDaysThreshold: {
      type: Number,
      required: true
    },
    cardColour: {
      type: String,
      default: ""
    },
    read: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: "0"
    },
    owner: {
      type: Object,
      required: true
    },
    referrerId: {
      type: null,
      default: null
    },
    referrer: {
      type: Object,
      default: () => ({})
    },
    reminders: {
      type: Array,
      default: () => []
    },
    followUpCount: {
      type: String,
      default: "0"
    },
    customFields: {
      type: Array,
      required: true
    },
    labelText: {
      type: String,
      default: ""
    },
    labelColour: {
      type: String,
      default: ""
    },
    isDisplayedInSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCardSettings: false,
      killDrag: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails"])), mapState("BoardStore", ["clientProfileIdsWithChanges"])), mapGetters("BoardStore", [CUSTOM_FIELDS_DEFINITIONS, SELECTED_BOARD, GET_PROFILE_PARTICIPANTS])), {}, {
    clientProfileHasLastChanges() {
      var _this$clientProfileId;
      return (_this$clientProfileId = this.clientProfileIdsWithChanges[this.id]) == null ? void 0 : _this$clientProfileId.hasChangelog;
    },
    currentUser() {
      return this.userDetails.username;
    },
    customFieldsDefinitions() {
      return this.CUSTOM_FIELDS_DEFINITIONS(this.isDisplayedInSearch ? this.boardId : this.SELECTED_BOARD.id);
    },
    rottenClass() {
      return this.rottingDaysThreshold > 0 && this.daysSinceLastActive >= this.rottingDaysThreshold;
    },
    cardColourStyle() {
      return this.cardColour ? `border-left: 4px solid ${this.cardColour}; 
          padding-left: calc(1rem - 4px) !important;` : "";
    },
    hasReferrer() {
      return !!this.referrerId;
    },
    orderedCustomFields() {
      const profileCustomFields = this.customFields;
      if (isEmpty(this.customFieldsDefinitions)) return [];
      return sortBy(profileCustomFields, [field => {
        var _this$customFieldsDef, _this$customFieldsDef2;
        return _parseInt((_this$customFieldsDef = this.customFieldsDefinitions) == null ? void 0 : (_this$customFieldsDef2 = _this$customFieldsDef.byId[field.id]) == null ? void 0 : _this$customFieldsDef2.fieldOrder);
      }, field => {
        var _this$customFieldsDef3, _this$customFieldsDef4;
        return moment((_this$customFieldsDef3 = this.customFieldsDefinitions) == null ? void 0 : (_this$customFieldsDef4 = _this$customFieldsDef3.byId[field.id]) == null ? void 0 : _this$customFieldsDef4.createdAt).unix();
      }]);
    },
    hasVisibleParticipants() {
      return this.participants.some(p => p.cardVisibility);
    },
    visibleParticipants() {
      var _context;
      return _filterInstanceProperty(_context = this.participants).call(_context, p => p.cardVisibility);
    },
    participants() {
      return this.GET_PROFILE_PARTICIPANTS(this.id);
    },
    translatedReferrerTypes() {
      var _context2;
      return _reduceInstanceProperty(_context2 = REFERRER_TYPE_OPTIONS()).call(_context2, (acc, curr) => {
        acc[curr.id] = curr.text;
        return acc;
      }, {});
    }
  }),
  async mounted() {
    if (this.isDisplayedInSearch) {
      await this.LOAD_CUSTOM_FIELDS_DEFINITIONS({
        boardId: this.boardId
      });
      await this.MERGE_CUSTOM_FIELDS_DATA({
        clientProfileId: this.id,
        customFieldsDefinitions: this.CUSTOM_FIELDS_DEFINITIONS(this.boardId)
      });
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [CLEAR_COMPLETE_CLIENT_PROFILE_REMINDERS, UPDATE_CLIENT_PROFILE_REMINDER, LOAD_CUSTOM_FIELDS_DEFINITIONS, MERGE_CUSTOM_FIELDS_DATA])), {}, {
    toggleCardSettings(value) {
      this.showCardSettings = value != null ? value : !this.showCardSettings;
    },
    handleReminderComplete(reminder) {
      this.UPDATE_CLIENT_PROFILE_REMINDER({
        clientProfileId: this.id,
        reminder
      });
    },
    showAddActivityModal() {
      showBModal("add-activity-note-modal", {
        clientProfileId: this.id
      }, this);
    },
    async handlePopoverClose() {
      if (!this.reminders.length) return;
      await this.CLEAR_COMPLETE_CLIENT_PROFILE_REMINDERS({
        clientProfileId: this.id
      });
      if (!this.reminders.length) this.showAddActivityModal();
    },
    link(clientProfileId, boardId) {
      return {
        name: "client-profile",
        params: {
          boardId,
          clientProfileId
        }
      };
    },
    handleReminderChange(reminder) {
      this.UPDATE_CLIENT_PROFILE_REMINDER({
        clientProfileId: this.id,
        reminder
      });
    },
    handleGoToProfile() {
      this.$router.push({
        name: "client-profile",
        params: {
          clientProfileId: this.id,
          boardId: this.boardId
        }
      });
    },
    handleMousedown() {
      this.killDrag = true;
      setTimeout(() => {
        this.killDrag = false;
      }, 100);
    },
    handleMouseup() {
      if (this.killDrag) {
        this.handleClick();
      }
    },
    handleClick: debounce(function () {
      if (!this.isDisplayedInSearch) {
        this.handleGoToProfile();
      }
    }, 50)
  })
});